import LegalLayout from '@/pages/legal/components/LegalLayout';

export default function Confidentialite() {
  return (
    <LegalLayout
      eyebrow="Protection des données"
      title="Politique de confidentialité"
      updatedAt="Septembre 2026"
      intro="MEDICACLIC accorde une importance particulière à la protection de votre vie privée. Cette politique décrit quelles données sont collectées, pourquoi elles le sont, pendant combien de temps elles sont conservées et quels sont vos droits, conformément à la loi 09-08 relative à la protection des données personnelles au Maroc et aux recommandations de la CNDP."
    >
      <h2>1. Responsable du traitement</h2>
      <p>
        Le responsable du traitement est <strong>MEDICACLIC</strong>, représentée par Mme Lamia Doghmi
        (ICE 003548663000080), établie à Rabat. Pour toute question relative à vos données,
        écrivez à <strong>contact@medicaclic.com</strong>.
      </p>

      <h2>2. Données collectées</h2>
      <ul>
        <li><strong>Recherche :</strong> critères de recherche (spécialité, quartier, ville), sans identification directe.</li>
        <li><strong>Compte patient :</strong> nom, prénom, numéro de téléphone.</li>
        <li><strong>Rendez-vous :</strong> praticien choisi, date et heure, motif éventuel, historique des RDV.</li>
        <li><strong>Praticiens :</strong> identité professionnelle, coordonnées, spécialité, tarifs, contenus de la fiche.</li>
        <li><strong>Données techniques :</strong> journaux de connexion et données de navigation strictement nécessaires au fonctionnement et à la sécurité du service.</li>
      </ul>

      <h2>3. Finalités et bases légales</h2>
      <p>
        Vos données sont traitées pour : la fourniture du service de mise en relation et de prise de
        rendez-vous ; l'envoi des confirmations et rappels de rendez-vous ; la gestion des comptes et
        de la relation avec les praticiens ; la sécurité et la prévention des abus ; le respect de nos
        obligations légales. Chaque traitement repose sur l'exécution du service demandé, votre
        consentement, ou notre intérêt légitime à sécuriser la plateforme.
      </p>

      <h2>4. Durée de conservation</h2>
      <p>
        Les données de compte sont conservées tant que le compte est actif, puis supprimées ou
        anonymisées après une période d'inactivité raisonnable. Les données de rendez-vous sont
        conservées le temps nécessaire au suivi de la relation et au respect des obligations légales.
        Les données strictement techniques sont conservées pour une durée limitée.
      </p>

      <h2>5. Destinataires et partage</h2>
      <p>
        Vos données ne sont accessibles qu'aux personnes habilitées de MEDICACLIC et, lorsque cela est
        nécessaire au rendez-vous, au praticien concerné (nom, prénom, téléphone, créneau). Certains
        prestataires techniques (hébergement, messagerie WhatsApp) peuvent intervenir strictement
        pour les besoins du service. <strong>Aucune donnée n'est cédée, louée ou revendue</strong>,
        et aucune publicité tierce n'est diffusée sur la plateforme.
      </p>

      <h2>6. Sécurité</h2>
      <p>
        Nous mettons en œuvre des mesures techniques et organisationnelles appropriées pour protéger
        vos données contre l'accès non autorisé, la perte ou l'altération : chiffrement des échanges,
        contrôle des accès, cloisonnement des données. Même si aucun système n'est infaillible, ces
        mesures réduisent significativement les risques.
      </p>

      <h2>7. Vos droits</h2>
      <p>
        Conformément à la loi 09-08, vous disposez des droits suivants, exerçables à tout moment :
      </p>
      <ul>
        <li>Droit d'accès à vos données personnelles ;</li>
        <li>Droit de rectification des données inexactes ;</li>
        <li>Droit d'opposition et de suppression pour motif légitime ;</li>
        <li>Droit de retirer votre consentement lorsque le traitement est fondé sur celui-ci.</li>
      </ul>
      <p>
        Pour exercer ces droits, écrivez à <strong>contact@medicaclic.com</strong>. Vous pouvez
        également adresser une réclamation à la <strong>CNDP</strong> (Commission Nationale de
        contrôle de la protection des Données à caractère Personnel).
      </p>

      <h2>8. Cookies</h2>
      <p>
        Le site n'utilise que des cookies et stockages techniques nécessaires à son fonctionnement
        (préférences d'affichage, session). Aucun cookie publicitaire ou de pistage tiers n'est
        déposé sans votre consentement.
      </p>

      <h2>9. Modifications</h2>
      <p>
        Cette politique peut être mise à jour pour refléter l'évolution du service ou de la
        réglementation. La date de dernière mise à jour figure en haut de cette page.
      </p>
    </LegalLayout>
  );
}